
const isUnAuthorize = () => {
  const userToken = localStorage.getItem("token");
  if (!userToken) return 1;
  return 0;
};

const checkAuthorization = () => {
  const tokenString = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  if (!tokenString) {
    localStorage.clear();
    window.location.href = "/";
    return null; 
  }
  const userToken = `Bearer ${tokenString}`;

  return { userToken, userId };
};

const checkAuthorizationWithoutLogin = () => {
  const userToken = localStorage.getItem("token");
  const user_id = localStorage.getItem("userId");
  const key = "2b223e5cee713616hs54ac203b24e9a123703VT001";

  // This condition doesn't make sense — key is hardcoded
  // Remove this check unless you have a real dynamic key
  // if (!key) { ... } → always false

  return {
    userToken: userToken || null,
    user_id: user_id || null,
    key,
  };
};

const getUserID = () => {
  return localStorage.getItem("userId") || null;
};

export {
  isUnAuthorize,
  checkAuthorization,
  checkAuthorizationWithoutLogin,
  getUserID,
};
